import script from "./assign.vue?vue&type=script&setup=true&lang=js"
export * from "./assign.vue?vue&type=script&setup=true&lang=js"

import "./assign.vue?vue&type=style&index=0&id=919fdd30&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/v8-production-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-919fdd30"]])

export default __exports__